import { atom } from "recoil";
import { AddressProps } from "../../components/address-input/address-props";
export const businessAdressState = atom<AddressProps | null>({
  key: "businessAdressState",
  default: null,
});
